import ProtectedPage from '@/components/ProtectedPage'
import { SupportThread } from '@/components/SupportPage/SupportThread'
import { FlowHeader } from '@/ui/core/flow-header'
import { Screen } from '@/ui/core/screen'
import { router, useLocalSearchParams } from 'expo-router'

const goBack = () => (router.canGoBack() ? router.back() : router.replace('/'))

/** The support thread as a pushed screen, for deep links and the places that pass a draft. */
export default function SupportScreen() {
	const { draft } = useLocalSearchParams<{ draft?: string }>()
	return (
		<ProtectedPage requireActiveMembership={false}>
			<Screen preset="fixed" className="flex flex-1" safeAreaEdges={['top', 'bottom']}>
				<FlowHeader onBack={goBack} />
				<SupportThread draft={draft} />
			</Screen>
		</ProtectedPage>
	)
}
